import { Injectable } from '@angular/core';
import { ICON_NAMES } from '../bayadic-shared-models/enums/Enums';
import { ITEM_TYPES } from '../bayadic-shared-models/item/item-types';
@Injectable()

export class IconsService {
  constructor(
  ) {

  }
  getIconNameIcon(collectionType: ITEM_TYPES) {
    let iconName;
    switch (collectionType) {
      case ITEM_TYPES.Dictionary:
        iconName = ICON_NAMES.Dictionary;
        break;
      case 'news':
        iconName = 'paper-plane';
        break;
      case 'partner':
        iconName = 'people';
        break;
      case 'puzzle':
        iconName = 'apps';
        break;
      case 'idiom':
        // check for the equivalent
        iconName = 'ios-quote';
        break;
      case 'quiz':
        iconName = 'ribbon';
        break;
      case 'artikelQuiz':
        iconName = 'ribbon';
        break;
      case 'imageQuiz':
        iconName = 'ribbon';
        break;
      case 'translationQuiz':
        iconName = 'ribbon';
        break;
      case 'leitner':
        iconName = 'cube';
        break;
    }
    return iconName;
  }
}
